/* Native scrolling, with optional arrows and mouse dragging. No autoplay. */
if (!customElements.get('wioletta-carousel')) {
  customElements.define('wioletta-carousel', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
    }
    initialize() {
      this.gallery = this.querySelector('.wioletta-lifestyle__gallery');
      if (!this.gallery || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.controls = this.querySelector('.wioletta-lifestyle__controls');
      this.items = [...this.querySelectorAll('.wioletta-lifestyle__item')];
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.position = this.querySelector('.wioletta-lifestyle__position');
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.gallery.scrollBy({ left: Number(button.dataset.direction) * this.step(), behavior: this.motion() });
      }, options));
      this.gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.gallery.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button') || !this.overflow()) return;
        this.drag = { id: event.pointerId, x: event.clientX, left: this.gallery.scrollLeft, moved: false };
        this.gallery.setPointerCapture(event.pointerId);
      }, options);
      this.gallery.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (Math.abs(delta) > 5) this.drag.moved = true;
        if (!this.drag.moved) return;
        this.gallery.classList.add('is-dragging');
        this.gallery.scrollLeft = this.drag.left - delta;
        event.preventDefault();
      }, options);
      const endDrag = () => {
        if (!this.drag) return;
        const { id, moved } = this.drag;
        this.drag = null;
        if (this.gallery.hasPointerCapture(id)) this.gallery.releasePointerCapture(id);
        this.gallery.classList.remove('is-dragging');
        if (moved) this.gallery.scrollTo({ left: Math.round(this.gallery.scrollLeft / this.step()) * this.step(), behavior: this.motion() });
      };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => this.gallery.addEventListener(type, endDrag, options));
      this.gallery.addEventListener('dragstart', event => event.preventDefault(), options);
      document.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.wioletta-lifestyle__item');
        if (!item || !this.contains(item)) return;
        const left = item.getBoundingClientRect().left - this.gallery.getBoundingClientRect().left + this.gallery.scrollLeft;
        this.gallery.scrollTo({ left, behavior: 'auto' });
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.gallery);
      this.update();
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    overflow() { return this.gallery.scrollWidth - this.gallery.clientWidth > 2; }
    step() {
      return this.items.length > 1 ? Math.abs(this.items[1].offsetLeft - this.items[0].offsetLeft) || 1 : this.gallery.clientWidth || 1;
    }
    update() {
      const max = this.gallery.scrollWidth - this.gallery.clientWidth;
      this.controls.hidden = !this.overflow();
      this.buttons.forEach(button => { button.disabled = Number(button.dataset.direction) < 0 ? this.gallery.scrollLeft <= 2 : this.gallery.scrollLeft >= max - 2; });
      const bounds = this.gallery.getBoundingClientRect();
      const visible = this.items.map((item, i) => ({ i, rect: item.getBoundingClientRect() })).filter(({ rect }) => rect.left >= bounds.left - 2 && rect.left < bounds.right - 2);
      if (visible.length) this.position.textContent = `${visible[0].i + 1}–${visible[visible.length - 1].i + 1} / ${this.items.length}`;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.drag = null;
    }
  });
}
